// ==============================|| THEME CONSTANT  ||============================== //

export const gridSpacing = 3;
export const drawerWidth = 280;

// ==============================|| THEME CONFIG  ||============================== //

const config = {
  /**
   * the props used for default theme palette mode
   * explore the default theme
   * below theme options -
   * 'light' (default)
   * 'dark'
   */
  theme: 'light',

  /**
   * the props used for default theme direction
   * explore the default theme
   * below theme options -
   * 'false' (default)
   * 'true'
   */
  rtlLayout: false,

  /**
   * The props used for display menu-items with multi-language.
   * We provide static below languages according to 'react-intl' options - https://www.npmjs.com/package/react-intl
   * 'en' (default)
   * 'fr'
   * 'ro'
   * 'zh'
   */
  i18n: 'en'
};

export default config;
